import { render } from "./Top.vue?vue&type=template&id=6958c5d8&scoped=true"
const script = {}

import "./Top.vue?vue&type=style&index=0&id=6958c5d8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6958c5d8"]])

export default __exports__